import styled from 'styled-components';
import { Colors } from '~/config/Colors';

export const CardContainer = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;

  width: 100%;
  max-width: 100%;
  padding: 16px;
  gap: 8px;

  border-radius: 8px;
  border: 1px solid #ffffff15;
  background-color: ${Colors.bgCardColor};
  box-shadow: rgba(0, 0, 0, 0.3) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${Colors.Border_Color_1 || '#ffffff25'};
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CardTitle = styled.h3`
  color: ${Colors.text_Color_1};
  font-size: 1.1em;
  font-weight: 700;
`;

export const CardSubTitle = styled.p`
  color: ${Colors.text_Color_1};
  font-size: 0.7em;
  font-weight: 300;
`;

export const AddButton = styled.button`
  background: #ffffff10;
  border: 1px solid ${Colors.Border_Color_1 || '#ffffff25'};
  border-radius: 8px;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${Colors.text_Color_1};
  font-size: 0.65em;
  font-weight: 400;

  cursor: pointer;

  transition-timing-function: ease-in-out;
  transition-duration: 300ms;
  transition-property: background;

  &:hover {
    background: #ffffff20;
  }
  &:active {
    background: #ffffff30;
  }
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${Colors.primary_Color_1};
  }
  &:disabled {
    background: #ffffff05;
    color: #ffffff50;
    cursor: not-allowed;
  }
`;
